export default __webpack_public_path__ + "static/media/plurifonds_it.partner.icon.ecf84d76.svg";